export class AssessmentTimerData {
    public binaryStartDate?: Date;
    public binaryEndDate?: Date;
    public binaryElapsedSeconds: number;

    public scaleStartDate?: Date;
    public scaleEndDate?: Date;
    public scaleElapsedSeconds: number;

    public textStartDate?: Date;
    public textEndDate?: Date;
    public textElapsedSeconds: number;
}


// WEBPACK FOOTER //
// ./src/models/AssessmentTimerData.tsx